import { useState, useEffect } from "react";
import { Box, Grid, Typography, Grid as MuiGrid } from "@material-ui/core";
import { Link } from "react-router-dom";
import ModulockerLogo from "assets/images/modulocker.png";
import useStyles from "./styles";
import styled from "styled-components";

export const PageContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const PageWrapper = styled.div`
  margin: auto;
  width: 100%;
  max-width: 1120px;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// export const Link = styled.a`
//   margin-right: 10px;
//   text-decoration: underline;
//   color: #00f;
// `;

const Container = styled(MuiGrid)`
  width: 60%;
  align-items: center;

  &.MuiGrid-spacing-xs-4 {
    margin: 0;
  }

  @media (min-width: 960px) {
    justify-content: space-between;
  }
`;

export function ServerErrorTemplate() {
  const classes = useStyles();
  const [role, setRole] = useState("");
  useEffect(() => {
    const storageUser = localStorage.getItem(
      "@partnerModulockerMultiLojas:user"
    );
    if (storageUser) {
      const user = JSON.parse(storageUser);
      setRole(user.roles[0].name);
    }
  }, []);
  return (
    <PageContainer>
      <PageWrapper>
        <Container>
          <Grid>
            <Box display="flex" flexDirection="column">
              <Grid container justifyContent="center" className={classes.logo}>
                <img src={ModulockerLogo} width={183} height={58} />
              </Grid>
              <Box flexDirection="column" className={classes.container} p={7}>
                <Grid container spacing={3}>
                  <Typography variant="h3" className={classes.title}>
                    Falha de conexão com o Servidor
                  </Typography>
                </Grid>
                <Typography variant="h4" className={classes.subtitle}>
                  <Link
                    style={{
                      marginRight: "10px",
                      textDecoration: "underline",
                      color: "#00f",
                    }}
                    to="/dashboard"
                  >
                    Clique aqui
                  </Link>
                  para atualizar
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item lg={3} md={3} sm={3}></Grid>
        </Container>
      </PageWrapper>
    </PageContainer>
  );
}
